import { useNavigate } from "react-router-dom";
import { Modal, Button, Typography, Icon } from "@/components/atoms";

interface OnboardingCompleteModalProps {
  open: boolean;
  onClose: () => void;
}

export const OnboardingCompleteModal = ({ open, onClose }: OnboardingCompleteModalProps) => {
  const navigate = useNavigate();

  const handleGoToBookingManager = () => {
    navigate("/bookings");
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} className="max-w-md px-[30px] pb-14 pt-12">
      <div className="flex flex-col items-center justify-start gap-4">
        <div className="relative flex size-20 items-center justify-center rounded-full bg-primary-light">
          <Icon name="Like1" size="xl" className="text-primary" variant="Bold" />
        </div>

        <Typography variant="h3" className="text-center text-neutral-dark-gray">
          You&apos;re all set to go! 🎉
        </Typography>

        <Typography variant="paragraph" className="text-center text-neutral-dark-gray">
          You&apos;ve completed the quick setup—your account is ready to start running operations.
        </Typography>

        <div className="w-full space-y-2 rounded-lg bg-neutral-surface-gray p-5">
          <Typography variant="title" className="text-neutral-dark-gray">
            🕒 What&apos;s next?
          </Typography>
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            You are now ready to begin managing your clients and bookings inside your booking manager
          </Typography>
        </div>

        <div className="w-full">
          <Button variant="primary" className="w-full" onClick={handleGoToBookingManager}>
            Go to Booking Manager
          </Button>
        </div>
      </div>
    </Modal>
  );
};
